<template>
  <div style="width: 100%">
    <mx-panel v-if="!IsDelete && value" :type="config.Type" :value="value" :config="Config" panel="SystemList2" :selected="selected" :index="index" @event="OnEvent">
      <template>
        <div class="flex-row" style="width: 100%">
          <div class="wf left" style="color: #878a99">名称</div>
          <div class="wf left" style="color: #878a99">企业</div>
          <div class="wf left" style="color: #878a99">培训人数</div>
          <div class="wf left" style="color: #878a99">培训课件数</div>
          <div class="wf left" style="color: #878a99">操作</div>
        </div>
      </template>

      <template slot="content" slot-scope="data">
        <div class="flex-row start middle border-bottom" style="width: 100%; padding: 20px 0">
          <div class="wf flex-row start list active">
            {{ value.Title || value.Name }}
          </div>
          <div class="wf flex-row start list">
            {{ value.Company.Name }}
          </div>
          <div class="wf flex-row start list">
            <div>{{ value.UsersCount }}</div>
            <div class="active pointer" @click="onShowUser">查看</div>
          </div>
          <div class="wf flex-row start list">
            <div>{{ value.VideoCount }}</div>
            <div class="active pointer" @click="onShowLesson">查看</div>
          </div>

          <div class="wf flex-row start list">
            <div class="flex-column">
              <div class="flex-row">
                <!-- <div class="pointer active f14" @click="onExportPDF">导出PDF</div> -->
                <div class="pointer active f14" @click="onExport">导出培训档案</div>

                <div class="pointer active m01 f14" @click="onAddLesson">添加课件</div>

                <div class="pointer active m01 f14" @click="onSelectUsers">选择培训人员</div>
              </div>
              <div class="flex-row start">
                <div class="pointer active f14 wf left" @click="data.handle.GoDetail(value, config)" v-if="IsDetail">详情</div>
                <div v-if="!GetDisabled('modify')" class="wf left">
                  <a class="active f14" href="javascript:void(0)" @click="OnModify">编辑</a>
                </div>
                <div v-if="!GetDisabled('del')" class="wf left">
                  <a class="active f14" href="javascript:void(0)" @click="OnDelete">删除</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div slot="button"></div>
    </mx-panel>
    <mx-element type="Dialog" theme="Pop" :config="DialogConfig" :key="key" title="企业学员培训记录" v-if="dialogVisible" :value="dialogVisible ? 1 : 0">
      <mx-page type="Home" theme="panel" :config="PageConfig" :value="value" name="企业学员培训记录" title="企业学员培训记录" :parent="value" :parent-type="config.Type" :key="key" />
    </mx-element>
    <mx-element type="Dialog" theme="Pop" :config="UsersConfig" :key="key" title="选择培训人员" v-if="showUsers" :value="showUsers ? 1 : 0">
      <mx-page type="Home" theme="Panel" :config="PageConfig" name="选择培训人员" title="选择培训人员" :parent="value" :parent-type="config.Type" :key="key" />
    </mx-element>
    <mx-element type="Dialog" theme="Pop" :config="TrainUsersConfig" :key="key" title="参培人员明细" v-if="showTrainUsers" :value="showTrainUsers ? 1 : 0">
      <mx-page type="Home" theme="Panel" :config="PageConfig" name="参培人员明细" title="参培人员明细" :parent="value" :parent-type="config.Type" :key="key" />
    </mx-element>
    <mx-element type="Dialog" theme="Pop" :config="LessonConfig" :key="key" title="培训课件" v-if="showLesson" :value="showLesson ? 1 : 0">
      <mx-page type="Home" theme="Panel" :config="PageConfig" name="培训课件" title="培训课件" :parent="value" :parent-type="config.Type" :key="key" />
    </mx-element>
    <mx-element type="Dialog" theme="Pop" :config="PDFConfig" :key="key" title="生成的PDF文件" v-if="showPDF" :value="showPDF ? 1 : 0">
      <div class="page-container p1">
        <div class="tip">
          <p>本次培训学员数量过多，为减少生成时间。将文件分为多个PDF文件，请点击下载。</p>
        </div>
        <template v-if="PDFList.length > 0">
          <div class="flex-row p10" v-for="(item, index) in PDFList" :key="index">
            <div class="wf left">{{ index + 1 }} 文件{{ index + 1 }}</div>
            <div class="wf left active pointer" @click="onOpen(item)">查看文件</div>
          </div></template
        >
        <template v-else>
          <div class="bw p1 m1">未生成任何PDF文件</div>
        </template>
      </div>
    </mx-element>
  </div>
</template>

<script>
let axios = require('axios')
import base from 'matrix.node.ui/libs/panels/base.js'
export default {
  props: {
    config: Object,
    value: Object,
    index: Number,
    role: String,
    roleField: String,
    name: String,
    selected: Object
  },
  mixins: [base],
  data() {
    return { PDFList: [], showPDF: false, fullscreenLoading: false, IsModify: false, IsDelete: false, Show: false, dialogVisible: false, key: new Date().getTime(), Query: {}, showUsers: false, showTrainUsers: false, showLesson: false }
  },
  computed: {
    SiteUrl() {
      return this.$matrix.Config.ImageSite
    },
    Config() {
      return Object.assign({ EventName: this.name ? this.name : 'TypeEvent', IsDark: false }, this.config)
    },
    IsDetail() {
      if (this.config.DetailView) return true
      return false
    },
    DialogConfig() {
      return {
        Width: '1200px',
        OnClose: () => {
          this.dialogVisible = false
        }
      }
    },
    PageConfig() {
      return {
        Role: this.config.Role,
        RoleField: this.config.RoleField,
        height: '100px'
      }
    },
    UsersConfig() {
      return {
        Width: '1200px',
        OnClose: () => {
          this.showUsers = false
        }
      }
    },
    PDFConfig() {
      return {
        Width: '600px',
        OnClose: () => {
          this.showPDF = false
        }
      }
    },
    TrainUsersConfig() {
      return {
        Width: '1200px',
        OnClose: () => {
          this.showTrainUsers = false
        }
      }
    },
    LessonConfig() {
      return {
        Width: '1200px',
        OnClose: () => {
          this.showLesson = false
        }
      }
    }
  },
  methods: {
    OnEvent(e) {
      this.$emit('event', e)
    },
    OnShow() {
      this.Show = true
    },
    onGoDetail() {
      let View = this.config.DetailView
      if (!View) return this.$matrix.ShowError('未配置详情视图')
      this.$emit('goview', {
        View: View,
        ViewType: '详情',
        Data: this.value,
        Role: this.config.Role,
        RoleField: this.config.RoleField
      })
    },
    onAddLesson() {
      this.$matrix.AddData(
        this.Context,
        {},
        {
          Type: 'Training.Lessons',
          Role: this.config.Role,
          RoleField: this.config.RoleField,
          Roles: this.config.Roles,
          RoleFieldData: this.config.RoleFieldData
        },
        (data) => {
          this.$emit('event', {
            target: 'item',
            name: 'Reload'
          })
        },
        this.value
      )
    },
    onExport() {
      this.dialogVisible = true
      this.key = new Date().getTime()
    },
    onSelectUsers() {
      this.showUsers = true
    },
    onShowLesson() {
      this.showLesson = true
    },
    onShowUser() {
      this.showTrainUsers = true
    },
    async onExportPDF() {
      let List = await this.LoadExamTicket()
      console.log(this.value, '1', List)
      let UserCount = List.length
      let CompleteCount = List.length
        ? List.filter((item) => {
            return [2, 3].indexOf(item.ExamResult) > -1
          }).length
        : 0
      let NoCompleteCount = UserCount - CompleteCount
      let data = {
        Name: this.value.Title,
        ExamTicketList: List,
        Company: this.value.Company.Name,
        StarTime: this.value.StartTime.substring(0, 10),
        EndTime: this.value.EndTime.substring(0, 10),
        CreateTime: new Date(this.value.CreateTime).getFullYear() + '-' + (new Date(this.value.CreateTime).getMonth() + 1),
        LessonCount: this.value.LessonsList.length,
        LessonTime: this.value.LessonsList.reduce((total, item) => {
          return (total += parseInt(item.LearnTime))
        }, 0),
        UserCount: UserCount,
        CompleteCount: CompleteCount,
        NoCompleteCount: NoCompleteCount
      } 
      const loading = this.$loading({
        lock: true,
        text: '学员图片较大，正在生成中！预计1-3分钟，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let res = await axios.post('https://wx.jiapingan.com/CreatePDF2', data)
  
      if (res && res.data) {
        loading.close()
        //let url = res.data.replace('upload', '')
        //window.open(`https://wx.jiapingan.com/${url}`)
        this.showPDF = true
        this.PDFList = res.data
      }
    },
    onOpen(url) {
      if (url) {
        console.log(url,'url')
        url = url.replace('E:/upload', '')
        console.log(url,'123')
        window.open(`https://wx.jiapingan.com/${url}`)
      }
    },
    async LoadExamTicket() {
      let res = await this.$matrix.AjaxGet3(
        'Exam.Ticket',
        'GetList',
        { Page: 1, PageSize: 0, GetUsers: true, GetParent: true, GetTraining: true, Training: this.value, ExamState: [2, 3], TrainingSearchParams: { GetLessonsList: true } },
        this.config.Role,
        this.config.RoleField
      )
      if (res && res.Items) {
        return res.Items.map((item) => {
          return {
            NickName: item.Users.NickName,
            Sex: item.Users.Sex === 1 ? '男' : '女',
            IDCard: item.Users.IDCard,
            ExamResultText: item.ExamResult === 2 ? '通过' : '不通过',
            ExamScore: item.ExamScore,
            FaceImage: this.SiteUrl + item.Users.FaceImage2,
            ExamResult: item.ExamResult
          }
        })
      }

      return []
    }
  }
}
</script>

<style scoped>
.wf {
  flex: 1;
}

.wf2 {
  flex: 2;
}

.border {
  border: 1px solid #eee;
}

.label_1,
.label_2,
.label_3 {
  border-radius: 4px;
  padding: 4px 6px;
  text-align: center;
}

.label_1 {
  background: #fbc451;

  color: #fff;
}

.label_2 {
  background: #a498cb;

  color: #fff;
}

.label_3 {
  background: #a7bba9;

  color: #fff;
}

.label_4 {
  background: #f49a71;

  color: #fff;
}

.label_5 {
  background: #6d72bb;

  color: #fff;
}

.active {
  color: #2d8cf0;
}

.red {
  color: #af1d26;
}

.text-line {
  text-decoration: line-through;
  color: gray;
}

span.button {
  color: #2d8cf0;
  cursor: pointer;
}

.image-box {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  opacity: 1;
  background-color: rgba(243, 246, 249, 1);
  padding: 4px;
}

.border-bottom {
  border-bottom: 1px solid #e9ebec;
}

/deep/ .el-dialog__body {
  padding: 0 10px;
}
.page-container .tip {
  padding: 8px 16px;
  background-color: #ecf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  margin: 20px 0;
}
</style>
